export const DIFFERENCE_VALUES = {
  ADDRESS: 'Address',
  ID: 'ID',
  NAME: 'Name',
  ORGANISATIONAL_GROUPS: 'Organisational Groups',
} as const;
